// components/CollateralTable.js
import React from "react";
import { getProtocolLogoText } from "../config";
import "../App.css";

export default function CollateralTable({
  allVaultsLoading,
  allVaultsError,
  sortedVaultData,
  selectedVault,
  onVaultRowClick,
  onVaultSort,
  vaultSortColumn,
  vaultSortDirection,

  timeframe,
}) {
  return (
    <div className="collateral-div">
      <div className="title-div">
        Collateral
        <div className="powered">
          <span className="power">Powered by</span>
          <img src="/vfyi.png" alt="vaultsfyi" className="vfyi" />
        </div>
      </div>

      <div className="table-div">
        {allVaultsLoading && (
          <div className="loading-text">Loading vaults...</div>
        )}
        {allVaultsError && (
          <div className="error-text">Error: {allVaultsError}</div>
        )}
        {!allVaultsLoading && !allVaultsError && (
          <table className="data-table">
            <thead>
              <tr className="label-row">
                <th className="table-header asset-header">Asset</th>
                <th className="table-header deposit-header">Deposit to</th>
                <th
                  className="table-header apy-header"
                  onClick={() => onVaultSort("apy")}
                >
                  APY
                  {vaultSortColumn === "apy" && ` (${vaultSortDirection})`}
                </th>
                <th
                  className="table-header tvl-header"
                  onClick={() => onVaultSort("tvl")}
                >
                  TVL
                  {vaultSortColumn === "tvl" && ` (${vaultSortDirection})`}
                </th>
              </tr>
            </thead>
            <tbody>
              {sortedVaultData.map((vault) => {
                const protocolString =
                  vault.protocol || vault.label || "Unknown Protocol";
                const vaultName = vault.name || vault.label || "Unknown Name";
                const logo = getProtocolLogoText(protocolString);

                // Instead of always "1day", use the timeframe prop
                const apyRaw = Number(vault.apy?.total?.[timeframe] ?? 0);
                const apyDecimal = apyRaw / 1e4;
                const apyPercent = (apyDecimal * 100).toFixed(2) + "%";

                const tvlUsd = parseFloat(vault.tvlDetails?.tvlUsd ?? "0");
                const tvlDisplay = tvlUsd.toLocaleString(undefined, {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                });

                const isSelected = selectedVault?.address === vault.address;

                return (
                  <tr
                    key={vault.address}
                    className={`data-row ${isSelected ? "selected-row" : ""}`}
                    onClick={() => onVaultRowClick(vault)}
                  >
                    <td className="table-cell asset-cell">
                      <div className="asset-content">
                        <img
                          src={`/${vault.token?.symbol}.png`}
                          alt={vault.token?.symbol}
                          className="asset-logo"
                        />
                        <span className="asset-name">
                          {vault.token?.symbol || "N/A"}
                        </span>
                      </div>
                    </td>
                    <td className="table-cell deposit-cell">
                      <div className="deposit-content">
                        {logo ? (
                          <img
                            src={`/${logo}`}
                            alt={protocolString}
                            className="protocol-logo"
                          />
                        ) : (
                          <div className="protocol-logo-placeholder" />
                        )}
                        <div className="protocol-cell">
                          <span className="protocol-name">{vaultName}</span>
                          <span className="protocol-name-sub">
                            {protocolString.charAt(0).toUpperCase() +
                              protocolString.slice(1)}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td className="table-cell apy-cell">{apyPercent}</td>
                    <td className="table-cell tvl-cell">
                      <div className="tvlvalue-cell">
                        <span className="tvl-value">${tvlDisplay}</span>
                        <span className="native-tvl">Native TVL</span>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
